var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1599_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3189 19.8057C46.2838 18.5876 44.9528 17.893 43.3364 17.9728C42.1696 18.0298 41.382 17.64 40.5608 16.8884C36.4552 13.1335 32.2967 9.43353 28.1468 5.72423C27.895 5.49926 27.8356 5.33235 27.962 5.0089C28.5465 3.51295 27.9933 1.85527 26.632 0.898393C25.3711 0.0109781 23.4988 0.0265261 22.2606 0.934675C20.9079 1.92887 20.3969 3.56893 20.9965 5.06592C21.0927 5.30644 21.0981 5.44743 20.8885 5.63714C16.3874 9.66645 11.8893 13.6989 7.39397 17.7344C7.22715 17.8562 7.02541 17.926 6.81594 17.9345C5.97862 18.0081 5.11752 17.9552 4.30504 18.1273C2.05776 18.6031 0.428477 20.6154 0.424155 22.8287C0.416232 27.0121 0.416232 31.1935 0.424155 35.3728C0.424155 37.9552 2.63362 40.126 5.32496 40.2173C5.51187 40.2235 5.69987 40.2225 5.88786 40.2225C18.276 40.2225 30.6652 40.2017 43.0545 40.238C46.0116 40.2473 48.0244 38.3263 48.3485 36.2063C48.3646 36.1662 48.3876 36.1291 48.4166 36.0964V22.1507C48.1778 21.3151 47.9088 20.5003 47.3189 19.8057ZM9.45542 17.9003L22.0867 6.56084C23.6846 7.65145 25.2631 7.6473 26.8567 6.56084L39.488 17.9003H9.45542Z",
    fill: "#33475B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1499 33.841V26.4219H17.9431V32.3847H21.0295V33.841H16.1499ZM22.7739 33.841V26.4219H27.947V27.8782H24.5671V29.3997H27.6825V30.8596H24.5671V32.3847H27.947V33.841H22.7739ZM29.6434 27.8782V26.4219H35.9141V27.8782H33.6644V33.841H31.8966V27.8782H29.6434Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1599_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "white",
    transform: "translate(0.416504 0.243225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLet);
export default __webpack_public_path__ + "static/media/let.a706625297044aea6b73ce99ad9d994e.svg";
export { ForwardRef as ReactComponent };